/**
 * @generated SignedSource<<56b721af89c37a5c3dc2d2e1e506442c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SignupViewRequestResetMutation$variables = {
  email: string;
};
export type SignupViewRequestResetMutation$data = {
  readonly requestPasswordReset: {
    readonly ok: boolean;
  };
};
export type SignupViewRequestResetMutation = {
  response: SignupViewRequestResetMutation$data;
  variables: SignupViewRequestResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "RequestPasswordResetPayload",
    "kind": "LinkedField",
    "name": "requestPasswordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignupViewRequestResetMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "SignupViewRequestResetMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "74b4c11ddf394ede702016007dc3b7a7",
    "id": null,
    "metadata": {},
    "name": "SignupViewRequestResetMutation",
    "operationKind": "mutation",
    "text": "mutation SignupViewRequestResetMutation(\n  $email: String!\n) {\n  requestPasswordReset(email: $email) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c1d40a3820d80ee7d1d71ef7d1f55cd";

export default node;
